import React, { Fragment, Component } from 'react';
import {
  InputGroup,
  InputGroupAddon,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from 'reactstrap';

const ENTER_KEY = 13;

export default class SearchCards extends Component {
  state = { searchModal: false, searchTerm: '' };

  render() {
    const { searchModal } = this.state;
    const { theme } = this.props;
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12 lodge-search d-none d-md-block">
            {/* <div className="d-flex flex-row justify-content-between"> */}
            {this.renderSearchFields()}
            {/* <span onClick={this.clearSearch} className="ml-2 mt-1">
                Clear
              </span> */}
            {/* </div> */}
          </div>
          <div className="col-md-2 col-4 d-sm-block d-md-none">
            <span className="float-left" onClick={this.toggleSearchModal}>
              Search
            </span>
          </div>{' '}
        </div>
        <Modal isOpen={searchModal} className="filters-modal" toggle={this.handleCancel}>
          <ModalHeader toggle={this.handleCancel}>
            <h3 className="res-view">{`SEARCH ${theme.toUpperCase()}`}</h3>
          </ModalHeader>
          <ModalBody>
            <div className="row mb-3">
              <div className="col-12 d-block d-md-none">
                <div className="lodge-search">{this.renderSearchFields()}</div>
              </div>
            </div>
            <ul className="btn-list">
              <li>
                <Button
                  className="btn-primary-action"
                  onClick={() => {
                    this.fetchCardsBySearchTerm({
                      searchTerm: this.state.searchTerm,
                    });
                    this.toggleSearchModal();
                  }}
                >
                  Apply
                </Button>
              </li>
              <li>
                <Button className="btn-primary-action" onClick={this.handleCancel}>
                  Cancel
                </Button>
              </li>
            </ul>
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }

  renderSearchFields() {
    const { theme } = this.props;
    const { searchTerm } = this.state;
    return (
      <InputGroup>
        <Input
          type="text"
          value={searchTerm}
          onChange={event => this.setSearchTerm({ searchTerm: event.target.value })}
          onKeyDown={event => this.handleKeyDown(event)}
          placeholder={`SEARCH ${theme.toUpperCase()} CARD`}
        />
        <InputGroupAddon addonType="append">
          <span className="input-group-text">
            {/* {searchTerm.length > 0 && (
              <i className="icon icon-hg-cross" onClick={this.clearSearch} />
            )} */}
            <i
              className="icon icon-hg-search"
              onClick={() => this.fetchCardsBySearchTerm({ searchTerm: searchTerm })}
            />
          </span>
        </InputGroupAddon>
      </InputGroup>
    );
  }

  handleKeyDown = event => {
    switch (event.keyCode) {
      case ENTER_KEY:
        this.fetchCardsBySearchTerm({ searchTerm: this.state.searchTerm });
        if (this.state.searchModal) {
          this.toggleSearchModal();
        }
        break;
      default:
        break;
    }
  };

  handleCancel = () => {
    const { searchTerm } = this.props.configs;

    if (searchTerm.length === 0) {
      this.setSearchTerm({ searchTerm: '' });
    } else if (searchTerm.length > 0) {
      this.setSearchTerm({ searchTerm });
    }
    this.toggleSearchModal();
  };

  clearSearch = () => {
    const { searchTerm } = this.props.configs;
    if (searchTerm.length > 0) {
      this.fetchCardsBySearchTerm({ searchTerm: '' });
    }
    this.setSearchTerm({ searchTerm: '' });
  };

  fetchCardsBySearchTerm = ({ searchTerm }) => {
    const { configs } = this.props;
    const { limit, categories } = configs;
    this.props.getCardsBySearchTerm({
      limit,
      page: 1,
      categories,
      searchTerm: searchTerm,
    });
  };

  setSearchTerm = ({ searchTerm }) => this.setState({ searchTerm });

  toggleSearchModal = () => this.setState({ searchModal: !this.state.searchModal });
}



// WEBPACK FOOTER //
// ./src/screens/Trek/SearchCards.js